import { css } from '@emotion/css';
import { AlignItems, BorderRadius, Color, Display, Font, FontWeight, JustifyContent, Spacing } from 'src/styles';

import { MTagType } from './MTag';

const getColorPalette = (type: MTagType): { color: string; background: string } => {
  switch (type) {
    case 'lightblue': {
      return {
        color: Color.Brand6,
        background: Color.Brand2,
      };
    }
    case 'blue':
      return {
        color: Color.Gray1,
        background: Color.Brand6,
      };
    case 'lightgreen':
      return {
        color: Color.Green8,
        background: Color.Green1,
      };
    case 'green':
      return {
        color: Color.Gray1,
        background: Color.Green6,
      };
    case 'lightred':
      return {
        color: Color.Red8,
        background: Color.Red1,
      };
    case 'red':
      return {
        color: Color.Red6,
        background: Color.Red2,
      };
    case 'orange':
      return {
        color: Color.Orange8,
        background: Color.Orange2,
      };
    default:
      return {
        color: Color.Gray7,
        background: Color.Brand1,
      };
  }
};

export const tag = (type: MTagType) => {
  const palette = getColorPalette(type);

  return css`
    border: none;
    ${BorderRadius.xxs}
    color: ${palette.color} !important;
    background-color: ${palette.background} !important;
    ${Spacing.px8}
    ${Spacing.py4}
    ${FontWeight.bold}
    ${Font.xs}
    ${AlignItems.center}
    ${Display.flex}
    ${JustifyContent.center}
  `;
};
